import { AylikVeri } from '../utils/raporHesapla';

interface Props {
  veriler: AylikVeri[];
}

export default function AylikPerformansTablosu({ veriler }: Props) {
  const reversed = [...veriler].reverse();
  const maxKazanc = Math.max(...veriler.map(v => v.toplamKazanc), 1);

  return (
    <div className="bg-white rounded-xl border border-gray-100">
      <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
        <div>
          <h3 className="text-sm font-bold text-gray-800">Aylık Performans Detayı</h3>
          <p className="text-xs text-gray-400 mt-0.5">Son 12 ay — en yeniden eskiye</p>
        </div>
        <button className="flex items-center gap-1.5 text-xs text-sky-600 hover:text-sky-800 font-semibold cursor-pointer whitespace-nowrap border border-sky-200 hover:border-sky-400 px-3 py-1.5 rounded-lg transition-colors">
          <i className="ri-download-line"></i>
          Dışa Aktar
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-100 bg-slate-50">
              <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Ay</th>
              <th className="text-center px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Servis</th>
              <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Toplam Kazanç</th>
              <th className="text-right px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide hidden sm:table-cell">Ort. Ücret</th>
              <th className="px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide hidden md:table-cell">Performans</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {reversed.map((v, i) => {
              const isCurrentMonth = i === 0;
              const barW = maxKazanc > 0 ? Math.round((v.toplamKazanc / maxKazanc) * 100) : 0;
              return (
                <tr key={`${v.yil}-${v.ayNo}`} className={`hover:bg-slate-50/60 transition-colors ${isCurrentMonth ? 'bg-sky-50/40' : ''}`}>
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-2">
                      {isCurrentMonth && (
                        <span className="w-1.5 h-1.5 rounded-full bg-sky-500 flex-shrink-0"></span>
                      )}
                      <span className="text-sm font-semibold text-gray-800">{v.ay} {v.yil}</span>
                      {isCurrentMonth && (
                        <span className="text-xs bg-sky-100 text-sky-600 px-1.5 py-0.5 rounded font-semibold">Bu Ay</span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3.5 text-center">
                    {v.servisSayisi > 0 ? (
                      <span className="text-sm font-bold text-gray-800">{v.servisSayisi}</span>
                    ) : (
                      <span className="text-sm text-gray-300">—</span>
                    )}
                  </td>
                  <td className="px-4 py-3.5 text-right">
                    {v.toplamKazanc > 0 ? (
                      <span className="text-sm font-bold text-emerald-600">₺{v.toplamKazanc.toLocaleString('tr-TR')}</span>
                    ) : (
                      <span className="text-sm text-gray-300">—</span>
                    )}
                  </td>
                  <td className="px-4 py-3.5 text-right hidden sm:table-cell">
                    {v.ortalamaUcret > 0 ? (
                      <span className="text-sm text-gray-600">₺{v.ortalamaUcret.toLocaleString('tr-TR')}</span>
                    ) : (
                      <span className="text-sm text-gray-300">—</span>
                    )}
                  </td>
                  <td className="px-5 py-3.5 hidden md:table-cell">
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div
                          className="h-2 rounded-full bg-sky-400 transition-all duration-500"
                          style={{ width: `${barW}%` }}
                        />
                      </div>
                      <span className="text-xs text-gray-400 w-8 text-right">{barW}%</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          {/* Toplam satırı */}
          <tfoot>
            <tr className="border-t-2 border-gray-200 bg-slate-50">
              <td className="px-5 py-3.5">
                <span className="text-sm font-bold text-gray-700">Toplam</span>
              </td>
              <td className="px-4 py-3.5 text-center">
                <span className="text-sm font-bold text-gray-800">
                  {veriler.reduce((s, v) => s + v.servisSayisi, 0)}
                </span>
              </td>
              <td className="px-4 py-3.5 text-right">
                <span className="text-sm font-bold text-emerald-700">
                  ₺{veriler.reduce((s, v) => s + v.toplamKazanc, 0).toLocaleString('tr-TR')}
                </span>
              </td>
              <td className="px-4 py-3.5 hidden sm:table-cell"></td>
              <td className="px-5 py-3.5 hidden md:table-cell"></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
